// [No] [op]erations
export const noop = () => {};
